import { SALARY_TYPE } from "./constanst/index";
import moment from "moment";
import defaultImage from "@/public/images/default.png";

export const parseUrlImage = (name) => {
  if (!name || String(name).trim() === "") return defaultImage;
  return process.env.NEXT_PUBLIC_BASE_URL_S3 + name;
};

export const parseSalary = (data) => {
  if (data?.salaryType == SALARY_TYPE.RANGE) {
    return `${new Intl.NumberFormat().format(
      data?.salaryMin
    )} VNĐ - ${new Intl.NumberFormat().format(data?.salaryMax)} VNĐ`;
  }

  return `${new Intl.NumberFormat().format(data?.salary)} VNĐ`;
};

export const capitalizeFirstLetter = (str) => {
  if (!str || String(str).trim() === "") return;
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const parseTimeType = (time, type) => {
  return `${time}h/${capitalizeFirstLetter(type)}`;
};

export const parseDate = (date, format = "MM/DD/YYYY") => {
  if (!date) return;
  return moment(new Date(date)).format(format);
};

export const truncateText = (text, length) => {
  if (text?.length > length) {
    return text.slice(0, length) + "...";
  }
  return text;
};

export const formatCurrency = (amount) => {
  if (!amount) return;
  return amount.toLocaleString("vi-VN").replace(/\./g, ",");
};


export const isPermission = (permission, path) => {
    if (path.includes("/candidates-dashboard/dashboard")) {
      return ['Owner','Collaborator', 'CompanyManager'].includes(permission)
    }
    if (path.includes("/candidates-dashboard/packages")) {
      return ['Owner','Collaborator', 'CompanyManager'].includes(permission)
    }
    if (path.includes("/candidates-dashboard/my-resume")) {
      return ['Candidates'].includes(permission)
    }
    if (path.includes("/candidates-dashboard/applied-jobs")) {
      return ['Candidates'].includes(permission)
    }
    if (path.includes("/candidates-dashboard/transaction")) {
      return ['Owner','Collaborator', 'CompanyManager'].includes(permission)
    }
    if (path.includes("/candidates-dashboard/my-profile")) {
      return ['Owner','Collaborator', 'FinancialSupport', 'Candidates'].includes(permission)
    }
    if (path.includes("/candidates-dashboard/cv-manager")) {
      return ['Owner', 'Collaborator', 'CompanyManager'].includes(permission)
    }
    if (path.includes("/candidates-dashboard/short-listed-jobs")) {
      return ['Owner', 'FinancialSupport'].includes(permission)
    }
}

export const clearParams = (data) => {
  return  Object.fromEntries(
    Object.entries(data).filter(([key, value]) => value != null && value !== "")
  );
}